import _ from 'lodash';

import { makeReactive } from '@dha/make-reactive';
import createChartModel from '@/model/ChartModelFactory';

const defaultOptions = {
    zoneDisclaimer: false
};

export default class SectionModel {
    constructor(parent, section, options) {
        this.parent = parent;
        this.section = section;
        this.options = {
            ...defaultOptions,
            ...options
        };
    }

    get id() {
        return this.options.id;
    }

    get domId() {
        return _.kebabCase(this.id);
    }

    get icon() {
        return this.parent.getIcon(this.options.icon);
    }

    get title() {
        return this.options.title;
    }

    get inspirationalQuote() {
        if (!this.options.inspirationalQuote) {
            return null;
        }
        return {
            content: this.options.inspirationalQuote,
            attribution: this.options.quoteAttribution,
            link: this.options.quoteLink
        };
    }

    get disclaimer() {
        if (!this.options.zoneDisclaimer) {
            return null;
        }
        return `${this.title} data is unavailable for LGA. Showing data for ${this.parent.comparisonName} zone.`;
    }

    get communityStoriesLink() {
        return this.options.communityStoriesLink;
    }

    get takeActionLink() {
        return this.options.takeActionLink;
    }

    get negativeTitle() {
        return this.options.negativeTitle || this.options.title;
    }

    get linkedTo() {
        return this.options.linkedTo;
    }

    get storyContent() {
        return this.options.storyContent;
    }

    get primaryBeliefMetric() {
        return this.options.primaryBeliefMetric;
    }

    get colorClass() {
        return this.options.colorClass;
    }

    get localName() {
        return this.parent.localName;
    }

    get allMetrics() {
        return this.parent.metricsBySection[this.section] || [];
    }

    get metrics() {
        return this.allMetrics.filter(({ isPrimary }) => isPrimary);
    }

    get metricModels() {
        return this.metrics.map(({ metric }) => makeReactive(createChartModel(
            this.parent.valuesByMetric[metric],
            this.parent,
            this.parent.metricsById[metric]
        )));
    }

    get primaryBeliefMetricModel() {
        if (!this.parent.valuesByMetric[this.primaryBeliefMetric]) {
            return null;
        }
        return makeReactive(createChartModel(
            this.parent.valuesByMetric[this.primaryBeliefMetric],
            this.parent,
            this.parent.metricsById[this.primaryBeliefMetric]
        ));
    }
}
